import React from 'react';
import { SunIcon, MoonIcon } from 'lucide-react';
interface HeaderProps {
  isDarkMode: boolean;
  onToggleDarkMode: () => void;
  totalContacts: number;
}
export function Header({
  isDarkMode,
  onToggleDarkMode,
  totalContacts
}: HeaderProps) {
  return <header className={`h-14 backdrop-blur border-b shrink-0 z-20 flex items-center justify-between px-6 transition-colors duration-300 ${isDarkMode ? 'bg-olympian-navy/80 border-olympian-border' : 'bg-white/90 border-gray-200'}`} data-id="element-54">
      <div className="flex items-center gap-3" data-id="element-55">
        <div className="w-7 h-7 bg-olympian-gold rounded-md flex items-center justify-center font-bold text-olympian-navy text-xs" data-id="element-56">
          OM
        </div>
        <span className="text-lg font-bold tracking-wide text-theme" data-id="element-57">
          Olympian Mortgage
        </span>
      </div>

      <div className="flex items-center gap-4" data-id="element-58">
        <div className="text-sm font-medium text-olympian-textMuted" data-id="element-59">
          <span className="text-theme font-bold" data-id="element-60">{totalContacts}</span> in
          pipeline
        </div>
        <div className="w-px h-4 bg-olympian-border" data-id="element-61" />
        <button onClick={onToggleDarkMode} className="p-2 rounded-lg transition-all duration-200 bg-olympian-surface border border-olympian-border text-olympian-textMuted hover:text-olympian-gold" aria-label={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'} title={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'} data-id="element-62">
          {isDarkMode ? <SunIcon className="w-4 h-4" data-id="element-63" /> : <MoonIcon className="w-4 h-4" data-id="element-64" />}
        </button>
      </div>
    </header>;
}